<template>
  <div class="pagination-container">
    <!-- Previous Button -->
    <!-- <button
      class="nav-btn"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
    >
      ← Previous
    </button> -->
    <button
      class="nav-btn"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
      aria-label="Previous page"
    >
      <img
        src="../icons/leftIcon.svg"
        alt=""
        class="nav-icon"
        aria-hidden="true"
      />
      <span class="nav-text">Previous</span>
    </button>

    <!-- Page Numbers -->
    <div class="pages">
      <button
        v-for="page in visiblePages"
        :key="page"
        @click="changePage(page)"
        :class="['page-btn', { active: currentPage === page }]"
      >
        {{ page }}
      </button>

      <span v-if="showEllipsisAfter">...</span>

      <button
        v-if="totalPages > 1 && !visiblePages.includes(totalPages)"
        @click="changePage(totalPages)"
        :class="['page-btn', { active: currentPage === totalPages }]"
      >
        {{ totalPages }}
      </button>
    </div>

    <!-- Next Button -->
    <!-- <button
      class="nav-btn"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)"
    >
      Next →
    </button> -->
    <button
      class="nav-btn"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)"
      aria-label="Next page"
    >
      <span class="nav-text">Next</span>
      <img
        src="../icons/rightIcon.svg"
        alt=""
        class="nav-icon"
        aria-hidden="true"
      />
    </button>
  </div>
</template>

<!-- <script>
export default {
  name: "Pagination",
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    value: {
      // v-model support
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      currentPage: this.value,
    };
  },
  watch: {
    value(val) {
      this.currentPage = val;
    },
    currentPage(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    visiblePages() {
      const delta = 2;
      const pages = [];
      const start = Math.max(1, this.currentPage - delta);
      const end = Math.min(this.totalPages, this.currentPage + delta);
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    showEllipsisAfter() {
      return (
        this.visiblePages[this.visiblePages.length - 1] < this.totalPages - 1
      );
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script> -->
<script>
import { trackPageChange } from "@/utils/trackInteraction";

export default {
  name: "Pagination",
  props: {
    totalPages: { type: Number, required: true },
    modelValue: { type: Number, default: 1 }, // modern v-model
    // Reporting context only — which list this pager belongs to and which
    // layout it was rendered in. Both ride along on the page-change event so
    // the admin Clicks tab can tell dashboard paging from directory paging.
    listType: { type: String, default: "" },
    viewMode: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  computed: {
    currentPage: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    visiblePages() {
      const delta = 2;
      const pages = [];
      const start = Math.max(1, this.currentPage - delta);
      const end = Math.min(this.totalPages, this.currentPage + delta);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    showEllipsisAfter() {
      return this.visiblePages[this.visiblePages.length - 1] < this.totalPages - 1;
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        // Every control in this pager (Prev, a numbered button, the last-page
        // button, Next) funnels through here, so this single call covers them
        // all. Programmatic page changes — back-from-detail restore, a filter
        // resetting to page 1 — set `currentPage` directly and are NOT tracked,
        // which is what we want: this counts clicks, not page state.
        trackPageChange({
          from: this.currentPage,
          to: page,
          totalPages: this.totalPages,
          listType: this.listType,
          view: this.viewMode,
        });
        this.currentPage = page;
      }
    },
  },
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 10px 20px;
  width: 100%;
  max-width: 1280px !important;
  margin: auto;
}

.nav-icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}

.nav-icon path {
  fill: currentColor;
}

.nav-text {
  line-height: 1;
  font-family: "Inter", sans-serif;
  font-weight: 600px;
  line-height: 20px;
  color: #535862;
}

.nav-btn {
  background: none;
  border: none;
  color: #444;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
}

.nav-btn:disabled {
  color: #aaa;
  cursor: not-allowed;
  opacity: 0.7;
}

.pages {
  display: flex;
  gap: 10px;
  align-items: center;
}

.page-btn {
  background: none;
  border: none;
  color: #555;
  font-weight: 500;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
}

.page-btn.active {
  background-color: #ede3ff;
  color: #7F56D9;
  font-weight: 600;
}
.nav-btn img{
  width: 15px;
  height: 15px;
}
/* 📱 Responsive Pagination Styles */

/* For tablets and smaller laptops */
@media (max-width: 768px) {
  .pagination-container {
    padding: 8px 12px;
    gap: 10px;
  }

  .page-btn {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }

  .nav-text {
    font-size: 14px;
  }

  .nav-icon {
    width: 14px;
    height: 14px;
  }
}

/* For mobile screens */
@media (max-width: 480px) {
  .pagination-container {
    justify-content: center;
    flex-wrap: nowrap;
    gap: 8px;
    padding: 6px 8px;

  }

  .pagination-container::-webkit-scrollbar {
    display: none;             /* hide scrollbar (WebKit browsers) */
  }

  .pages {
    display: flex;
    flex-wrap: nowrap;
    gap: 6px;
  }

  .page-btn {
    min-width: 26px;
    height: 26px;
    font-size: 12px;
    border-radius: 4px;
    flex-shrink: 0;
  }

  .nav-btn {
    padding: 4px 6px;
    gap: 4px;
  }

  /* Hide text for mobile, keep only icons */
  .nav-text {
    display: none;
  }

  .nav-btn img,
  .nav-icon {
    width: 14px;
    height: 14px;
    object-fit: contain;       
    
  }

  .page-btn.active {
   background-color: #ede3ff !important;
  color: #7F56D9 !important;
  font-weight: 600;
  }
}

</style>
